export const environment = {
    production: false,
  
    clientName: 'cambulos',
    apiGatewayFront: 'https://ecommerceagr.avicambulos.com.co/',
    apiGatewayBackOffice: 'https://ecommerceagr.avicambulos.com.co/',
    apiUrl: 'https://ecommerceagr.avicambulos.com.co/',
    urlPath: 'https://ecommerceagr.avicambulos.com.co/',
    customCss: false,
    applicationType: "agr",
    // Whether or not to enable debug mode
    // Setting this to false will disable console output
    enableDebug: false,
    // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
    // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX
  
    siteKeyCaptcha: '6LdzNFclAAAAAE0nDkLRbDHXK_kztBwVf4VY4uXf',
  
    googleAnalyticsCode: 'UA-140785247-1',
  };
  
  
  const environment2 = {
    production: false,
    clientName: 'cambulos',
    apiGatewayFront: 'https://ecommerceagr.avicambulos.com.co/',
    apiGatewayBackOffice: 'https://ecommerceagr.avicambulos.com.co/',
    apiUrl: 'https://ecommerceagr.avicambulos.com.co/',
    urlPath: 'https://ecommerceagr.avicambulos.com.co/',
    customCss: false,
    // Whether or not to enable debug mode
    // Setting this to false will disable console output
    enableDebug: false,
    // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
    // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX
    siteKeyCaptcha: '6LdzNFclAAAAAE0nDkLRbDHXK_kztBwVf4VY4uXf',
    googleAnalyticsCode: 'UA-140785247-1',
  };